export const TUTORIAL_STEPS_DESCRIPTION = {
  aires: {
    label: 'AIRES files',
    activeTab: {
      title: 'AIRES files',
      body: 'This tab lists every AIRES file pair you’ve uploaded. Each upload is the source for everything you’ll see downstream.',
    },
    uploadsTable: {
      title: 'Uploads table',
      body: 'Each row is one upload: file names, document date, and processing status. Status updates automatically as the file is processed.',
    },
    dataQualityCell: {
      title: 'Check data quality',
      body: 'Click Open Validation Results to compare your submission to the most recent call report on file. Warnings flag values outside typical ranges (ex: credit scores beyond 300–850). Not necessarily errors, just worth a look.',
    },
    uploadDataBtn: {
      title: 'Upload Data',
      body: 'To upload a new set of files, click here. For easier automation, we recommend the SFTP or PowerShell transfer methods.',
    },
  },

  loans: {
    label: 'Loans Mapping',
    whatWhy: {
      title: 'Loans Mapping',
      body: 'Match each of your loan codes to a DEXA product type to include them in your analyses. Any codes left unmatched will be excluded.',
    },
    unmappedCounter: {
      title: 'Unmapped loan codes',
      body: 'Loan codes that still need a type. Unmapped codes are excluded from analysis, so the goal is zero.',
    },
    editBtn: {
      title: 'Edit',
      body: 'Open inline edit to assign a loan type to every code on one screen. For codes you’ve already mapped, you can change the type from the same view.',
    },
    checkboxes: {
      title: 'Checkboxes',
      body: 'Another way you can update codes is by selecting specific codes via checkboxes.',
    },
    bulkUnmap: {
      title: 'Unmap Loan Type',
      body: 'Removes the loan type from every selected code. Use it when products were mapped incorrectly. You can assign a new type right away or leave the codes unmapped.',
    },
    bulkAssign: {
      title: 'Assign Loan Type',
      body: 'Assigns one loan type to all selected codes at once. It’s the fastest way to map a group of similar products.',
    },
    moreActions: {
      addNewProduct: {
        title: 'Add New Product',
        body: 'Add a loan code by hand for a product that isn’t in your AIRES file yet, such as a new loan product you’re about to launch.',
      },
      downloadTemplate: {
        title: 'Download Pre-filled Loan Template',
        body: 'A spreadsheet pre-filled with your loan codes. It’s the fastest way to map a large code set. Set the type for each code, then upload the completed file back.',
      },
      uploadMapFile: {
        title: 'Upload Loan Map File',
        body: 'Upload your completed loan map file. Opens the upload page in this app.',
      },
      openSpec: {
        title: 'Open Product Mapping Specification',
        body: 'The full written mapping guide that explains what each loan type covers and how to choose. Opens in a new tab.',
      },
    },
  },

  shares: {
    label: 'Shares Mapping',
    whatWhy: {
      title: 'Shares Mapping',
      body: 'Match each of your share codes to a standard share type: savings, money market, CDs, IRAs, and so on. Required for correct analysis. Buttons are identical to the Loans Mapping tab.',
    },
  },

  pfc: {
    label: 'Code Mapping',
    whatWhy: {
      title: 'Code Mapping (PFC)',
      body: 'Payment Frequency Codes (PFC) tell the system how often your loans are paid: weekly, monthly, quarterly, and so on. Match each code from your loan file to a standard meaning.',
    },
    unmappedCounter: {
      title: 'Unmapped PFC codes',
      body: 'PFC codes that still need a meaning. Unmapped codes are skipped in any frequency-based analysis, so the goal is zero.',
    },
    editBtn: {
      title: 'Edit',
      body: 'Open inline edit to assign a meaning to every PFC code on one screen. For codes you’ve already mapped, you can change the definition from the same view.',
    },
    singleEdit: {
      title: 'Single edit',
      body: 'Use a pencil icon to map a payment frequency code. It’s an alternative way to update single mapping.',
    },
    moreActions: {
      downloadTemplate: {
        title: 'Download Pre-filled PFC Template',
        body: 'A spreadsheet pre-filled with your PFC codes. Set the meaning for each code and upload the completed file back.',
      },
      uploadMapFile: {
        title: 'Upload PFC Map File',
        body: 'Upload your completed PFC map file. Opens the upload page in this app.',
      },
      openSpec: {
        title: 'Open Product Mapping Specification',
        body: 'The full written mapping guide that explains what each meaning covers and how to choose. Opens in a new tab.',
      },
    },
  },
} as const;
